import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HistorialPagosDetalladosComponent } from './components/historial-pagos-detallados/historial-pagos-detallados.component';
import { EpaycoCredijamarComponent } from './components/epayco-credijamar/epayco-credijamar.component';

const routes: Routes = [
  {
    path: "historial-pagos-detallado",
    component: HistorialPagosDetalladosComponent,
    data: {
      title: 'Historial de pagos detallado'
    }
  },
  {
    path: "epayco-credijamar",
    component: EpaycoCredijamarComponent,
    data: {
      title: 'Reporte epayco-credijamar'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportesRoutingModule { }